import React, { useState } from "react";
import { Eye, EyeClosed } from "lucide-react";
import "./MaskedCurrencyValue.css";

/**
 * Displays a currency/KPI value with optional eye toggle masking (same as Sales Total Sale / Net Profit).
 */
const MaskedCurrencyValue = ({
  value,
  className = "",
  valueClassName = "",
  maskable = true,
  defaultVisible = false,
  maskedPlaceholder = "********",
}) => {
  const [visible, setVisible] = useState(defaultVisible);

  if (!maskable) {
    return <span className={valueClassName || className}>{value}</span>;
  }

  return (
    <div className={`kpi-masked-value ${className}`.trim()}>
      <span className={valueClassName}>{visible ? value : maskedPlaceholder}</span>
      <button
        type="button"
        className="kpi-mask-toggle-btn"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? "Hide value" : "Show value"}
      >
        {visible ? <Eye size={16} /> : <EyeClosed size={16} />}
      </button>
    </div>
  );
};

export default MaskedCurrencyValue;
